// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationArrowLeft: React.FC<{ width?: number; height?: number }> = ({ width = 18, height = 18 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 18">
            <path
                fill="currentColor"
                d="M.317 9.798c-.423-.423-.423-1.173 0-1.596L8.195.317c.422-.423 1.173-.423 1.595 0 .422.422.422 1.173 0 1.596l-5.956 5.96h13.04C17.484 7.874 18 8.39 18 9s-.516 1.126-1.126 1.126H3.834l5.956 5.961c.422.423.422 1.174 0 1.596-.469.423-1.173.423-1.595 0L.317 9.798Z"
            />
        </svg>
    );
};

export default React.memo(PaginationArrowLeft);
